import { combineReducers } from 'redux'
import { loadingBarReducer } from 'react-redux-loading-bar'
import site from './site'
import page from './page'
import schedule from './schedule'
import programs from './programs'
import facebook from './facebook'
import votd from './votd'

export default combineReducers({
	loadingBar: loadingBarReducer,
	site: site,
	page: page,
	schedule: schedule,
	programs: programs,
	facebook: facebook,
	votd: votd
})
